// useEventTracker.ts
import { useEffect, useRef, useCallback } from 'react';
import { EventTracker, TrackedEvent, UseEventTrackerOptions } from '../model/UseEventTrackerTypes';

export function useEventTrackerImpl(options: UseEventTrackerOptions): EventTracker {
    const { flushInterval = 60000, bufferSize = 50, sendEvents } = options;
    const bufferRef = useRef<TrackedEvent[]>([]);
    const timerRef = useRef<number | null>(null);

    const flush = useCallback(async () => {
        const toSend = bufferRef.current;
        if (!toSend.length) return;
        bufferRef.current = [];
        try {
            await sendEvents(toSend);
        } catch (err) {
            bufferRef.current.unshift(...toSend);
            console.error('Errore invio eventi:', err);
        }
    }, [sendEvents]);

    const trackEvent = useCallback((name: string, properties?: Record<string, any>) => {
        bufferRef.current.push({ name, properties, timestamp: new Date() });
        if (bufferRef.current.length >= bufferSize) {
            void flush();
        }
    }, [bufferSize, flush]);

    useEffect(() => {
        timerRef.current = window.setInterval(() => { void flush(); }, flushInterval);
        return () => {
            if (timerRef.current !== null) window.clearInterval(timerRef.current);
            void flush();
        };
    }, [flush, flushInterval]);

    return { trackEvent, flush };
}
